import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": ".88",
      d: "M8 12.068a5.12 5.12 0 1 0 0-10.24 5.12 5.12 0 0 0 0 10.24Z"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "8",
      cy: "10.642",
      fill: "currentColor",
      rx: ".96",
      ry: ".24"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.384 13.16a1.6 1.6 0 0 1-.282.243l-.062.042-.07.03a.28.28 0 0 0-.149.164c-.065.177.03.348.156.398.829.33 1.882.524 3.023.524 1.14 0 2.194-.194 3.023-.524.126-.05.222-.22.156-.398a.28.28 0 0 0-.15-.164l-.069-.03-.062-.042a1.6 1.6 0 0 1-.281-.243A6.5 6.5 0 0 1 8 13.71a6.5 6.5 0 0 1-2.616-.55"
    }, null, -1)
  ])))
}
export default { render: render }